module.exports = __webpack_public_path__ + "static/media/data.bd763d4b.png";